// components/DataTable.js - Table component (Updated - Removed ID and Status columns)
import React from 'react';
import { RefreshCw, Download, MessageSquare } from 'lucide-react';
import { styles } from '../styles';
import { utils } from '../utils';

const DataTable = ({
                       loading,
                       filteredData,
                       searchTerm,
                       connectionStatus,
                       hasActiveFilters,
                       resetFilters,
                       pagination,
                       loadMoreData
                   }) => {
    return (
        <div style={styles.tableContainer}>
            <div style={styles.tableHeader}>
                <h2 style={styles.tableTitle}>Access Entries</h2>

                {loading ? (
                    <div style={styles.loadingContainer}>
                        <RefreshCw size={32} style={{ color: '#a855f7', animation: 'spin 1s linear infinite', marginRight: '12px' }} />
                        <span>Loading access data...</span>
                    </div>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={styles.table}>
                            <thead>
                            <tr>
                                <th style={{ ...styles.tableHeaderCell, fontSize: '1rem' }}>Timestamp</th>
                                <th style={{ ...styles.tableHeaderCell, fontSize: '1.4rem' }}>Origin</th>
                                <th style={{ ...styles.tableHeaderCell, fontSize: '1.3rem' }}>Destination</th>
                                <th style={{ ...styles.tableHeaderCell, fontSize: '1.2rem' }}>Message</th>
                            </tr>
                            </thead>
                            <tbody>
                            {filteredData.map((entry, index) => (
                                <tr
                                    key={entry.id || index}
                                    style={styles.tableRow}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <td style={{ ...styles.tableCell, ...styles.tableCellGray, fontSize: '1rem' }}>
                                        {utils.formatTimestamp(entry.timestamp)}
                                    </td>
                                    <td style={{ ...styles.tableCell, fontSize: '1rem' }}>
                      <span style={{
                          ...styles.badge,
                          ...styles.badgeBlue,
                          fontSize: '0.9rem',
                          ...(searchTerm && entry.access_origin?.toLowerCase().includes(searchTerm.toLowerCase()) ?
                              { backgroundColor: 'rgba(255, 193, 7, 0.3)', color: '#fbbf24' } : {})
                      }}>
                        {entry.access_origin || 'Unknown'}
                      </span>
                                    </td>
                                    <td style={{ ...styles.tableCell, ...styles.tableCellWhite, fontSize: '1rem' }}>
                                        {entry.access_destination || 'Unknown'}
                                    </td>
                                    <td style={{
                                        ...styles.tableCell,
                                        ...utils.getStatusColor(entry.message),
                                        fontSize: '1rem',
                                        ...(searchTerm && entry.message?.toLowerCase().includes(searchTerm.toLowerCase()) ?
                                            { backgroundColor: 'rgba(255, 193, 7, 0.1)', borderLeft: '3px solid #fbbf24', paddingLeft: '9px' } : {})
                                    }}>
                                        {entry.message || 'No message'}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                        {filteredData.length === 0 && !loading && (
                            <div style={styles.emptyState}>
                                <MessageSquare size={48} style={styles.emptyIcon} />
                                <p>
                                    {connectionStatus === 'disconnected'
                                        ? 'No backend connection. Start your server to see access data.'
                                        : hasActiveFilters
                                            ? `No entries match your current filters. Search looks in Origin and Message columns.`
                                            : 'No access entries found in the selected table.'}
                                </p>
                                {hasActiveFilters && (
                                    <button
                                        onClick={resetFilters}
                                        style={{
                                            ...styles.button,
                                            ...styles.buttonSecondary,
                                            marginTop: '12px'
                                        }}
                                    >
                                        Clear All Filters
                                    </button>
                                )}
                            </div>
                        )}

                        {/* Load More Button */}
                        {pagination.hasMore && filteredData.length > 0 && (
                            <div style={{ padding: '16px', textAlign: 'center', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                                <button
                                    onClick={loadMoreData}
                                    disabled={loading}
                                    style={{
                                        ...styles.button,
                                        ...(loading ? styles.buttonDisabled : styles.buttonSecondary)
                                    }}
                                    onMouseOver={(e) => {
                                        if (!loading) {
                                            e.target.style.backgroundColor = '#1d4ed8';
                                        }
                                    }}
                                    onMouseOut={(e) => {
                                        if (!loading) {
                                            e.target.style.backgroundColor = '#2563eb';
                                        }
                                    }}
                                >
                                    {loading ? (
                                        <>
                                            <RefreshCw size={16} style={{ animation: 'spin 1s linear infinite' }} />
                                            Loading...
                                        </>
                                    ) : (
                                        <>
                                            <Download size={16} />
                                            Load More ({pagination.totalRecords - filteredData.length} remaining)
                                        </>
                                    )}
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DataTable;